import type { LicenceExistsResponse, LicenceResponse, UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { toCsmCandidates } from '../../_shared/domain/licence-csm';
import { clientCategoriesHttp } from '../../_shared/infrastructure/client-categories.http';
import type { AddLicenceGateway } from './add-licence.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the create-licence endpoints (kept 1:1 with the original `AddLicence` page's
 * `api.post('/licences', { name })`). `api.post`/`api.get` unwrap the `{ data }`
 * envelope, so these resolve directly to the payloads.
 */
export const httpAddLicenceGateway: AddLicenceGateway = {
  ...clientCategoriesHttp,
  createLicence: (input) => api.post<LicenceResponse>('/licences', input),
  checkNameExists: async (name) => {
    const { exists } = await api.get<LicenceExistsResponse>(
      `/licences/exists?name=${encodeURIComponent(name)}`,
    );
    return exists;
  },
  // The Administrators index, narrowed to who may be picked; the server
  // re-checks the pick on create (#583).
  loadCsmCandidates: async () =>
    toCsmCandidates(await api.get<UserResponse[]>('/users?role=admin')),
};
